import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';

import {router} from './routes/mainRoutes'
import {store} from './store/store'

import axios from 'axios'

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import JQuery from 'jquery'
window.$ = JQuery;

import "bootstrap";
import "popper.js";

import "font-awesome/css/font-awesome.min.css";
import "bootstrap/dist/css/bootstrap-grid.min.css";
import "bootstrap/dist/css/bootstrap-reboot.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import "@/assets/css/web.css";
/*---------End Custom/3rd Party Library CSS and Javascript can be added here -----*/


Vue.config.productionTip = false

axios.defaults.baseURL = process.env.VUE_APP_API_URL //live or local
//axios.defaults.baseURL = process.env.VUE_APP_API_URL_BETA //beta
// const session = Vue.prototype.$session

// axios.interceptors.request.use(config =>{
//  console.log("in inst-req")
//   if(!navigator.onLine){
//     //alert("You are offline!!!")
//   }
//   if(session.exists()){//dashboard
//     if(session.has('ut')){
//       if(session.get('ut')=="Learner"){
//         axios.defaults.baseURL = process.env.VUE_APP_API_URL_Stud
//       }
//       else if(session.get('ut')=="Instructor"){
//         axios.defaults.baseURL = process.env.VUE_APP_API_URL_Inst
//       }
//       else if(session.get('ut')=="Admin"){
//         axios.defaults.baseURL = process.env.VUE_APP_API_URL_Inst
//       }
//       else{
//         axios.defaults.baseURL = process.env.VUE_APP_API_URL_Home
//       }
//     }
//     if(session.has('token')){
//       config.headers.common['token']=session.get('token')
//     }
//     if(session.has('uid')){
//       config.headers.common['uid']=session.get('uid')
//     }
//   }
//   else{
//     axios.defaults.baseURL = process.env.VUE_APP_API_URL_Home
//   }
//   config.headers.common['router-path']=router.currentRoute.path       
//   config.headers.common['device']="Web"       
//   return config
// })

// axios.interceptors.response.use(res =>{
//   console.log("res-url:"+res.request.responseURL)
//   console.log("res-status:"+res.status)
//   if(res.data.status=="200"){
//     //success
//     // store.dispatch('setSnackbar',{
//     //   showing:true,
//     //   timeout:5000,
//     //   color:'#008000',
//     //   text:"success..."
//     // })
//   }
//   else if(res.data.status=="100"){ //token refreshed
//     session.set("token",res.data.token)
//   }
//   else if(res.data.msg=="401"){
//     store.dispatch('setSnackbar',{
//       showing:true,
//       timeout:5000,
//       color:'#008000',
//       text:"Duplicate login. Please login again..."
//     })
//     router.push("/")
//   }
//   else if(res.data.msg=="403"){
//     store.dispatch('setSnackbar',{
//       showing:true,
//       timeout:5000,
//       color:'#008000',
//       text:"Access Denied!!!"
//     })
//     router.push("/")
//   }
//   return res
// })

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
